import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Poi } from "../../../types";
import NoDataNotice from "../BaseComponents/NoDataNotice";
import { useEditState } from "../EditContext";
import { useAppState } from "../../../AppContext";
import { MenuItemTitle, StyledMenuItem } from "../../Sidebar/MenuItemStyles";
import { makeKeyDownHandler } from "../../../utils/a11y-utils";

const PoiOverview = () => {
  const { target, setTarget } = useEditState();
  const { state } = useAppState();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/editor/poi" && target) {
      setTarget(undefined);
    }
  }, [location.pathname, setTarget, target]);

  return (
    <div style={{ overflowY: "auto" }}>
      {state.pois.length === 0 ? (
        <NoDataNotice />
      ) : (
        <div>
          {state.pois.map((poi: Poi) => (
            <StyledMenuItem key={poi.id} className={target === poi.id ? "active" : ""}>
              <div
                onClick={() => history.push(`/editor/poi/${poi.id}`)}
                onKeyDown={makeKeyDownHandler(() => history.push(`/editor/poi/${poi.id}`))}
                role="button"
                tabIndex={0}
              >
                <MenuItemTitle>{poi.title}</MenuItemTitle>
              </div>
            </StyledMenuItem>
          ))}
        </div>
      )}
    </div>
  );
};

export default PoiOverview;
